/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deal_Provision_Basis_SaleInputs */

const cs_deal_provision_basis_sale = /** @type {(inputs: Deal_Provision_Basis_SaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kupní / prodejní cena`)
};

const en_deal_provision_basis_sale = /** @type {(inputs: Deal_Provision_Basis_SaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sale / purchase price`)
};

/**
* | output |
* | --- |
* | "Sale / purchase price" |
*
* @param {Deal_Provision_Basis_SaleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_provision_basis_sale = /** @type {((inputs?: Deal_Provision_Basis_SaleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Provision_Basis_SaleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_provision_basis_sale(inputs)
	return cs_deal_provision_basis_sale(inputs)
});